import { ISameCaseMatchedCasesSearchModel, SameCaseSortColumns } from '../manage/useGetSameCasesQuery';
import { UseMutationOptions, useMutation } from 'react-query';

import ApiClient from '../../../../services/apiClient';
import { HttpResponseError } from '../../../../interfaces/IHttpResponseError';
import { IPagedSortedSearchResponseModel } from '../../../../interfaces/PagedSortedSearch';

const _apiClient = new ApiClient();

export interface ICaseGroupMatchCaseResponseModel {
    caseGuid: string;
    organizationGuid: string;
    organizationName: string;
    caseNumber: string;
    caseName: string;
    jurisdiction: string;
    caseGroupGuid?: string | null;
    uniqueCaseId: string;
    plaintiffFirm: string;
    nationalPlaintiffFirm: string;
}

export const useSameCasesAdminSearchMutation = (
    reactQueryOptions?: UseMutationOptions<
        IPagedSortedSearchResponseModel<ICaseGroupMatchCaseResponseModel, SameCaseSortColumns> | undefined,
        unknown,
        ISameCaseMatchedCasesSearchModel,
        unknown
    >
) => {
    return useMutation({
        mutationFn: async (searchModel: ISameCaseMatchedCasesSearchModel) => {
            const response = await _apiClient.searchSameCaseCasesAdmin(searchModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to search case groups');
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
        ...reactQueryOptions,
    });
};
